<template>
    <div id="userList">
        <div class="searchContent" id="search">
            <div class="p_select search_day_list">
                <div class="search_label">查询日期</div>
                <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                    <el-date-picker
                            @change="dayPositionReport"
                            v-model="queryDay"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerDayOptions"
                            prefix-icon="''"
                            class="datepicker"
                            placeholder="选择日期">
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDateStart"></i>
                </div>
            </div>
            <div class="p_select">
                <el-button class="search_btn" @click="dayPositionReport"  >查询</el-button>
                <el-button class="add_btn" @click="exportExcel" v-if="showTabel">导出清单</el-button>
                <el-button class="add_btn" @click="downloadImg" v-if="showTabel">下载图片</el-button>
            </div>
        </div>
        <!--<div class="table" id="table" v-if="showTabel" :style="{width:headers.length * 100+'px'}">-->
        <div class="table" id="table" v-if="showTabel">
            <div class="title"><span>{{orgName}}  全车影像检测日报</span></div>
            <div class="day"><span>{{queryDay}}</span></div>
            <div class="sub_box">
                <div class="sub_item">
                    <div class="colour normal"></div>
                    <div class="describe normal_text"><span>配件检测正常</span></div>
                </div>
                <div class="sub_item">
                    <div v-if="isLynk*1 === 1" class="colour reception"></div>
                    <div v-if="isLynk*1 !== 1" class="colour normal_sale"><div class="normal"></div><div class="sale"></div></div>
                    <div class="describe sale_text">
                        <span v-if="isLynk*1 === 1" style="color: #cc0ee7">前置销售</span>
                        <span v-else>配件正常已销售</span>
                    </div>
                </div>
                <div class="sub_item">
                    <div class="colour abnormal"></div>
                    <div class="describe sale_text">
                        <span v-if="isLynk*1 === 1">增项销售</span>
                        <span v-else>配件异常已销售</span>
                    </div>
                </div>
                <div class="sub_item">
                    <div class="colour abnormal_no_sale"></div>
                    <div class="describe no_sale_text"><span>配件异常未销售</span></div>
                </div>
            </div>
            <div class="table_title">
                <div class="list_item" v-for="(item,index) in headers" :key="index"><span>{{item}}</span></div>
            </div>
            <div class="table_content">
                <div class="table_list" v-for="(list,index) in mgrid" :key="index">
                    <div class="list_item" v-for="(item,i) in headers" :key="i">
                        <span v-if="i < 3">{{list[i]}}</span>
                        <div v-if="i >= 3" class="colour_box">
                            <div class="colour" :style="{backgroundColor:colorIndex[list[i]]}" v-if="list[i]*1 != 3"></div>
                            <!--<div class="colour_normal_sale" v-if="list[i]*1 === 3"><div class="normal"></div><div class="sale"></div></div>-->
                            <div class="colour_normal_sale" v-if="list[i]*1 === 3 && isLynk*1 !== 1"><div class="normal"></div><div class="sale"></div></div>
                            <div class="reception" v-if="list[i]*1 === 3 && isLynk*1 === 1"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table_title">
                <div class="list_item"><span></span></div>
                <div class="list_item"><span></span></div>
                <div class="list_item"><span></span></div>
                <div class="list_item" v-for="(item,index) in del_headers" :key="index"><span>{{item}}</span></div>
            </div>
            <div class="table_content">
                <div class="table_list" v-for="(list,index) in mgrid_COUNT" :key="index">
                    <div class="list_item" v-for="(item,i) in list" :key="i"><span>{{item}}</span></div>
                </div>
            </div>
            <div class="table_title">
                <div class="list_item" v-for="(item,index) in counts" :key="index"><span>{{item}}</span></div>
            </div>
        </div>
        <div v-if="!showTabel">
            <span>暂无数据</span>
        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  import html2canvas from 'html2canvas';
  export default {
    data(){
      return {
        orgId: "",
        orgName: "",
        queryDay: "",
        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },

        colorIndex:[],
        headers:[],
        mgrid:[],
        mgrid_COUNT:[],
        counts:[],
        del_headers:[],
        list_data:[],

        winHeight:'200',
        showTabel: true,

        isLynk:'', //领克？？

      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if (signInfo.orgId > 0) {
        this.orgId = signInfo.orgId;
        this.orgName = signInfo.orgName
      }
      let obj = new Date();
      let month = obj.getMonth() + 1;
      let day = obj.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.queryDay = obj.getFullYear() + "-" + month + "-" + day;

      this.dayPositionReport()
    },
    methods: {
      onMouseOver(item) {
        this.$refs.iconDateStart.style.display = "none";
      },
      onMouseleave(item) {
        this.$refs.iconDateStart.style.display = "block";
      },

      dayPositionReport(){
        if(this.queryDay == '' || this.queryDay == null){
          net.message(this, '请选择需要查询的时间', "warning");
          return
        }
        this.colorIndex = []
        this.headers = []
        this.mgrid = []
        this.mgrid_COUNT = []
        this.counts = []
        const params = {
          // orgId: this.orgId,
          queryDay: this.queryDay
        };
        net.request("admin/manage/dataReport/dayPositionReportV1", "post", params).then(res => {
          if (res.code === 0) {
            let data = res.data
            if(data){
              this.showTabel = true
              this.colorIndex = data.colorIndex
              this.headers = data.headers
              this.mgrid = data.mgrid
              this.mgrid_COUNT = data.mgrid_COUNT
              this.counts = data.counts
              this.isLynk = data.isLynk //是否是领克店

              let del_headers = data.headers.slice(3)
              this.del_headers = del_headers

              let list_data = []
              data.mgrid.forEach(i => {
                let list = []
                i.forEach((item, index) => {
                  if(index < 3 || index > i.length - 3){
                    list.push(item)
                  }else {
                    if(item *1 === 0){
                      list.push('正常')
                    }
                    else if(item *1 === 1 || item *1 === 3){
                      list.push('已售')
                    }else if(item *1 === 2){
                      list.push('未售')
                    }else {
                      list.push('-')
                    }
                  }
                })
                list_data.push(list)
              })
              list_data.unshift(data.headers)
              this.list_data = list_data
              console.log("数据",list_data)

              const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
              this.winHeight = windiwHight - 168;
            }else {
              this.showTabel = false
            }




          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
      },

      //下载图片
      downloadImg(){
        const dataLength = this.mgrid.length + this.mgrid_COUNT.length;
        this.winHeight = dataLength * 58 + 500;
        setTimeout(() => {
          html2canvas(document.querySelector("#table")).then(canvas => {
            var saveFile = function(data, filename) {
              var save_link = document.createElementNS( "http://www.w3.org/1999/xhtml", "a" );
              save_link.href = data;
              save_link.download = filename;
              var event = document.createEvent("MouseEvents");
              event.initMouseEvent(
                "click",
                true,
                false,
                window,
                0,
                0,
                0,
                0,
                0,
                false,
                false,
                false,
                false,
                0,
                null
              );
              save_link.dispatchEvent(event);
            };

            const img = new Image();
            img.src = canvas.toDataURL("png");
            img.setAttribute("crossOrigin", "anonymous");
            canvas = document.createElement("canvas");
            const num = dataLength * 58 + 500;
            const imgWidth = document.body.clientWidth
            canvas.width = imgWidth;
            canvas.height = num;
            var ctx = canvas.getContext("2d");
            img.onload = function() {
              var w = img.width;
              var h = img.height;
              ctx.drawImage(img, 0, 0, w, h, 0, 0, w, h);
              var dataURL = canvas.toDataURL("image/png");
              saveFile(dataURL, "换件登记检测日报.png");
            };
          });
        }, 1000);
      },
      // 导出数据
      exportExcel() {
        let data = this.list_data
        // 将二维数组转换为工作表
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        // 创建工作簿并添加工作表
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        // 生成Excel文件并导出
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        FileSaver(dataBlob, '换件登记检测日报.xlsx');
      },
    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
    },
    beforeDestroy() {
      window.removeEventListener('keyup',this.handleKeyup)
    }
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 12px;
        padding-bottom: 10px;

        .searchContent {
            background: #fff;
            padding-top: 12px;
            margin-bottom: 12px;
            .p_select {
                display: flex;
                margin-right: 12px;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                height: 38px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

            .option_box{
                margin-bottom: 24px;
                display: flex;
                .option_item {
                    width: 200px;
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-weight: 400;
                    font-size: 14px;
                    text-align: center;
                    color: #364556;
                }
                .option_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }
            .option_item_box{
                margin-bottom: 24px;
                display: flex;
                .item_ {
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;

                    line-height: 36px;
                    padding: 0 24px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #364556;
                }
                .item_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }

        }
        .table {
            padding: 0 12px;
            min-width: 900px;
            .title {
                font-size: 18px;
                font-weight: 700;
            }
            .day {
                font-size: 14px;
                margin-top: 10px;
            }
            .sub_box {
                margin-top: 10px;
                margin-bottom: 10px;
                display: flex;
                .sub_item {
                    display: flex;
                    font-size: 16px;
                    height: 30px;
                    line-height: 30px;
                    margin-right: 10px;
                    .colour {
                        width: 100px;
                        height: 20px;
                        margin-top: 5px;
                        margin-right: 5px;



                    }
                    .normal {
                        background-color: #15B628;
                    }
                    .normal_sale {
                        display: flex;
                        .normal {
                            width: 50px;
                            height: 20px;
                            background-color: #15B628;
                        }
                        .sale {
                            width: 50px;
                            height: 20px;
                            background-color: #267ef0;
                        }
                    }
                    .abnormal {
                        background-color: #267ef0;
                    }
                    .abnormal_no_sale {
                        background-color: #ff4d00;
                    }
                    .normal_text {
                        color: #15B628;
                    }
                    .sale_text {
                        color: #267ef0;
                    }
                    .no_sale_text {
                        color: #ff4d00;
                    }
                    .reception {
                        background-color: #cc0ee7;
                    }
                }
            }

            .table_title {
                display: flex;
                /*justify-content: space-between;*/
                .list_item {
                    font-size: 16px;
                    font-weight: 700;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 2000px;
                }
                > :nth-child(-n+3) {
                    /* 样式规则 */
                    min-width: 70px !important;
                }
            }
            .table_content {
                .table_list {
                    display: flex;
                    > :nth-child(-n+3) {
                        /* 样式规则 */
                        min-width: 70px !important;
                    }
                }
            }
            .list_item {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 2000px;
                /*flex-grow: 1;*/
                /*flex-basis:200px;*/
                min-height: 50px;
                /*line-height: 50px;*/
                font-size: 14px;
                border: 1px solid #eeeeee;
                .colour_box {
                    display: flex;
                    justify-content: center;
                    .colour {
                        width: 30px;
                        height: 20px;
                        /*margin-top: 10px;*/
                    }
                    .colour_normal_sale {
                        display: flex;
                        margin-top: 10px;
                        .normal {
                            width: 15px;
                            height: 20px;
                            background-color: #15B628;
                        }
                        .sale {
                            width: 15px;
                            height: 20px;
                            background-color: #267ef0;
                        }
                    }
                    .reception {
                        width: 30px;
                        height: 20px;
                        background-color: #cc0ee7;
                    }
                }

            }

        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
        }
    }
</style>
